import React from 'react'
import { Card, Table, CardHeader } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  customerBank: PropTypes.shape({
    name           : PropTypes.string,
    holder_name    : PropTypes.string,
    account_number : PropTypes.string,
    branch         : PropTypes.string
  })
}

const defaultProps = {
  customerBank: {
    name           : '',
    holder_name    : '',
    account_number : '',
    branch         : ''
  }
}

const CustomerRefundPaymentBankDetailCard = ({ customerBank }) => (
  <Card>
    <CardHeader>Bank Account Detail</CardHeader>
    <Table hover>
      <tbody>
        <tr>
          <th scope='row'>Bank Name</th>
          <td>{ customerBank.name }</td>
        </tr>
        <tr>
          <th scope='row'>Holder Name</th>
          <td className='text-wrap'>{ customerBank.holder_name }</td>
        </tr>
        <tr>
          <th scope='row'>Account No</th>
          <td>{ customerBank.account_number }</td>
        </tr>
        <tr>
          <th scope='row'>Branch</th>
          <td>{ customerBank.branch }</td>
        </tr>
      </tbody>
    </Table>
  </Card>
)

CustomerRefundPaymentBankDetailCard.propTypes    = propTypes
CustomerRefundPaymentBankDetailCard.defaultProps = defaultProps

export default CustomerRefundPaymentBankDetailCard
